import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Cube } from "@phosphor-icons/react";

export default function LegalPage({ slug, fallbackTitle }) {
  const [data, setData] = useState({ title: fallbackTitle, body: "", updated_at: null });

  useEffect(() => {
    api.get(`/legal/${slug}`).then(({ data }) => setData(data)).catch(() => {});
  }, [slug]);

  const renderBody = () => {
    const lines = (data.body || "").split("\n");
    const els = [];
    let para = [];
    const flush = () => {
      if (para.length) { els.push(<p key={els.length} className="text-zinc-600 leading-relaxed text-[15px]">{para.join(" ")}</p>); para = []; }
    };
    lines.forEach((ln) => {
      if (ln.startsWith("## ")) { flush(); els.push(<h2 key={els.length} className="font-display text-xl font-bold text-zinc-900 pt-3">{ln.slice(3)}</h2>); }
      else if (ln.trim() === "") { flush(); }
      else para.push(ln.trim());
    });
    flush();
    return els;
  };

  return (
    <div className="min-h-screen bg-[#FAFAFB] text-zinc-950" data-testid={`legal-page-${slug}`}>
      <header className="sticky top-0 z-40 backdrop-blur-xl bg-white/70 border-b border-zinc-200">
        <div className="max-w-7xl mx-auto px-5 h-16 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2.5">
            <img src="/orbit-icon.jpg" alt="Orbit" className="h-9 w-9 object-contain rounded-md" />
            <span className="font-display font-bold text-sm tracking-tight"><span className="sm:hidden">Orbit</span><span className="hidden sm:inline">Orbit Inventory Management</span></span>
          </Link>
          <div className="flex items-center gap-2">
            <Link to="/login"><Button variant="ghost" className="h-10 font-semibold">Sign In</Button></Link>
            <Link to="/register"><Button className="h-10 bg-emerald-500 hover:bg-emerald-600 text-white font-semibold">Start Free</Button></Link>
          </div>
        </div>
      </header>

      <section className="max-w-3xl mx-auto px-5 pt-16 pb-8">
        <p className="text-xs uppercase tracking-[0.2em] font-semibold text-emerald-600 mb-3">Legal</p>
        <h1 className="font-display text-4xl sm:text-5xl font-extrabold tracking-tight" data-testid="legal-title">{data.title}</h1>
        {data.updated_at && (
          <p className="mt-3 text-sm text-zinc-400">Last updated {new Date(data.updated_at).toLocaleDateString(undefined, { month: "long", day: "numeric", year: "numeric" })}</p>
        )}
      </section>

      <section className="max-w-3xl mx-auto px-5 pb-20 space-y-5" data-testid="legal-body">
        {renderBody()}
      </section>

      <footer className="bg-zinc-950 text-zinc-500 border-t border-zinc-800">
        <div className="max-w-7xl mx-auto px-5 py-8 flex flex-col sm:flex-row items-center justify-between gap-4 text-sm">
          <div className="flex items-center gap-2"><Cube size={18} weight="bold" className="text-emerald-600" /> © {new Date().getFullYear()} Orbit Inventory Management</div>
          <div className="flex gap-6">
            <Link to="/" className="hover:text-white transition-colors">Home</Link>
            <Link to="/privacy" className="hover:text-white transition-colors">Privacy</Link>
            <Link to="/terms" className="hover:text-white transition-colors">Terms</Link>
          </div>
        </div>
      </footer>
    </div>
  );
}
